<template >
  <!-- <div class="avatars_list"> -->
  <section class="avatars-group stacked">
    <!-- {{avatarsStackedLimit}} -->
    <div
      v-for="avatar in avatarsStackedLimit"
      :key="`avatar-id-${avatar.id}`"
      class="avatars-group__item"
    >
      <!-- <x-tooltip content-class="x-tooltip x-tooltip-bottom" bottom>
          <template v-slot:activator="{ on, attrs }"> -->
      <!-- {{avatar[0]}} -->
      <profile-avatar :avatar="avatar" @click="$emit('click')">
      </profile-avatar>
      <!-- </template> -->
      <!-- <x-profile-tooltip :avatar="avatar" :presence="presence"></x-profile-tooltip>
        </x-tooltip> -->
    </div>
    <div class="avatars-group__item more">
      <v-avatar color="primary" size="24px">
        <v-menu
          v-model="stackedMenu"
          left
          :max-height="menuMaxHeight"
          nudge-bottom="8"
          offset-y
        >
          <template v-slot:activator="{ on }">
            <v-btn class="ma-2" v-on="on" color="indigo">
              <v-icon color="white" stroke="#D7D9E3"
                >mdi-dots-horizontal</v-icon
              >
            </v-btn>
          </template>
          <v-list dense two-line>
            <v-list-item
              v-for="avatar in avatarsSorted"
              :key="`avatar-menu-id-${avatar.id}`"
              avatar
            >
              <v-list-item-avatar>
                <profile-avatar
                  :avatar="avatar"
                  custom-class="bordered small"
                  size="32px"
                >
                </profile-avatar>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ avatar.alt }}</v-list-item-title>
                <v-list-item-subtitle>{{ avatar.role }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-avatar>
    </div>
  </section>
  <!-- <span v-if="avatarsSorted.length > avatarsStackedLimit.length"  class="more_item">+{{avatarsSorted.length - avatarsStackedLimit.length}}</span> -->
  <!-- </div> -->
</template>

<script>
import ProfileAvatar from "./ProfileAvatar.vue";

export default {
  name: "AvatarGroup",
  components: {
    ProfileAvatar,
  },
  props: {
    // avatars: {
    //   default: () => [],
    //   type: Array,
    // },
  },
  data() {
    return {
      menuMaxHeight: `${60 * 5 + 4}px`,
      presence: false,
      stackedLimit: 4,
      stackedMenu: false,
      displayMenu: false,
      avatars: [
        {
          alt: "John Smitt",
          id: 1,
          presence: "Online",
          role: "Frontend Engineer",
          src: null,
        },
        {
          alt: "Joanne Swizzlette",
          id: 2,
          presence: "Away",
          role: "Automation Engineer",
          src: "https://randomuser.me/api/portraits/med/women/3.jpg",
        },
        {
          alt: "Frankie Dowle",
          id: 4,
          presence: "Online",
          role: "Platform Architect",
          src: "https://randomuser.me/api/portraits/med/men/8.jpg",
        },
        {
          alt: "Annette Walker",
          id: 5,
          presence: "Online",
          role: "Head of UX",
          src: "https://randomuser.me/api/portraits/med/women/5.jpg",
        },
        {
          alt: "Danny Quaide",
          id: 6,
          presence: "Offline",
          role: "UI Designer",
          src: "https://randomuser.me/api/portraits/med/men/10.jpg",
        },
        {
          alt: "Paisley Arch",
          id: 7,
          presence: "Holiday",
          role: "Automation Engineer",
          src: "https://randomuser.me/api/portraits/med/women/7.jpg",
        },
        {
          alt: "Kenneth Boomstang",
          id: 8,
          presence: "Online",
          role: "Frontend Engineer",
          src: "https://randomuser.me/api/portraits/med/men/1.jpg",
        },
        {
          alt: "Donna Avery",
          id: 9,
          presence: "Online",
          role: "UX Researcher",
          src: "https://randomuser.me/api/portraits/med/women/2.jpg",
        },
        {
          alt: "Phillip Hargreaves",
          id: 10,
          presence: "Online",
          role: "Head of Quality",
          src: "https://randomuser.me/api/portraits/med/men/11.jpg",
        },
        {
          alt: "Melissa Tushoos",
          id: 11,
          presence: "Online",
          role: "Head of Platform Engineering",
          src: "https://randomuser.me/api/portraits/med/women/4.jpg",
        },
        {
          alt: "Justin Backbeard",
          id: 12,
          presence: "Busy",
          role: "Frontend Engineer",
          src: "https://randomuser.me/api/portraits/med/men/13.jpg",
        },
        {
          alt: "Amy Fullerton",
          id: 13,
          presence: "Busy",
          role: "UI Designer",
          src: "https://randomuser.me/api/portraits/med/women/6.jpg",
        },
        {
          alt: "Angus Dougherty",
          id: 14,
          presence: "Online",
          role: "Backend Engineer",
          src: null,
        },
        {
          alt: "Jess Cransley",
          id: 15,
          presence: "Online",
          role: "UX Advocate",
          src: "https://randomuser.me/api/portraits/med/women/8.jpg",
        },
        {
          alt: "Barry Morgan",
          id: 16,
          presence: "Away",
          role: "Frontend Architect",
          src: "https://randomuser.me/api/portraits/med/men/17.jpg",
        },
        {
          alt: "Warren Deekead",
          id: 17,
          presence: "Online",
          role: "Backend Engineer",
          src: "https://randomuser.me/api/portraits/med/men/19.jpg",
        },
        {
          alt: "Melissa Warmslent",
          id: 18,
          presence: "Holiday",
          role: "DevOps Engineer",
          src: "https://randomuser.me/api/portraits/med/women/12.jpg",
        },
      ],
    };
  },
  computed: {
    avatarsSorted() {
      return this.avatars || [];
    },
    avatarsStackedLimit() {
      return this.avatarsSorted.length
        ? this.avatarsSorted.slice(0, this.stackedLimit)
        : [];
    },
    avatarsDisplayed() {
      return this.displayMenu ? this.avatarsStackedLimit : this.avatars.length;
    },
  },
};
</script>

<style>
.avatars-group.grid {
  display: grid;
  grid-gap: 8px;
  grid-template-columns: repeat(auto-fit, minmax(48px, 1fr));
}
.avatars-group.stacked {
  display: flex;
  flex-direction: row;
  direction: ltr;
  max-width: 100%;
  overflow: hidden;
  overflow-x: auto;
  white-space: nowrap;
}
.avatars-group.stacked > * {
  margin-right: -8px;
}
.avatars-group.stacked > *:last-of-type {
  padding-right: 16px;
}
.avatars-group__item {
  cursor: default;
  transition: all 0.1s ease-out;
}
.avatars-group__item.more {
  align-items: center;
  display: flex;
}
.avatars-group__item.more:hover {
  transform: none;
}
.avatars-group__item:hover {
  transform: translateY(-4px);
  z-index: 1;
}
.avatars-group .v-avatar {
  box-shadow: 0px 0px 0px 2px #fff inset;
}
.avatars-group .v-avatar img {
  padding: 2px;
}
.avatars-group .v-avatar span {
  align-items: center;
  display: flex;
  font-size: 110%;
  font-weight: 700;
  height: 100%;
  justify-content: center;
  letter-spacing: 0.1rem;
  text-shadow: 0px 0px 2px rgba(0, 0, 0, 0.56);
  width: inherit;
}
.v-avatar.bordered {
  box-shadow: 0px 0px 0px 2px #fff inset;
}
.v-avatar.bordered img {
  padding: 2px;
}
.v-avatar.bordered.small {
  box-shadow: 0px 0px 0px 1px #fff inset;
}
.v-avatar.bordered.small img {
  padding: 1px;
}
.presence {
  box-shadow: 0px 0px 0px 2px #fff inset;
  border-radius: 50%;
  bottom: 0px;
  display: block;
  height: 14px;
  position: absolute;
  width: 14px;
}
.v-avatar.bordered.small .presence {
  box-shadow: 0px 0px 0px 1px #fff inset;
  display: block;
  height: 8px;
  position: absolute;
  width: 8px;
}
</style>